import hasIndex from './hasIndex';

export default hasIndex;
